import use123zapStore from "../../../context/123zapStore";
import { SentimentsAnalysis } from "../../../services/integrations/ai/SentimentsAnalysis";

export default function useSentimentsAI() {
  const {
    aiAnalysisText,
    aiAnalysisLoading,
    setAiAnalysis,
    setAiAnalysisLoading,
  } = use123zapStore();

  const generateAnalysis = async (data) => {
    try {
      setAiAnalysisLoading(true);

      const response = await SentimentsAnalysis(data);

      if (response?.data?.length > 0) {
        setAiAnalysis(response.data[0].message);
      } else {
        setAiAnalysis(
          "Não há dados suficientes para gerar análise."
        );
      }
    } catch (err) {
      console.error(err);
    } finally {
      setAiAnalysisLoading(false);
    }
  };

  return {
    aiAnalysisText,
    aiAnalysisLoading,
    generateAnalysis,
  };
}
